import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";

export default function Fleet() {
  const [fleet, setFleet] = useState([]);
  useEffect(() => { api.get("/fleet").then(r => setFleet(r.data)); }, []);

  return (
    <div data-testid="fleet-page">
      <Navbar/>
      <div className="pt-32 pb-10 px-6 md:px-12 max-w-7xl mx-auto">
        <p className="eyebrow mb-3">Fleet</p>
        <h1 className="font-serif text-5xl md:text-7xl mb-2">The <span className="italic gradient-gold">Collection.</span></h1>
        <div className="divider"/>
        <p className="text-[#6b7c8a] max-w-2xl">Hand-picked vehicles, immaculately maintained, professionally chauffeured.</p>
      </div>

      <section className="px-6 md:px-12 max-w-7xl mx-auto pb-24 grid md:grid-cols-2 gap-8">
        {fleet.map(v => (
          <div key={v.id} data-testid={`fleet-${v.id}`} className="card-dark overflow-hidden group">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={v.image} alt={v.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000"/>
            </div>
            <div className="p-8">
              <p className="eyebrow mb-2">{v.type}</p>
              <h3 className="font-serif text-2xl mb-3">{v.name}</h3>
              <div className="flex items-center gap-2 text-[#b8c5d1] text-sm mb-6">
                <Users size={14} className="text-[#5DCFE5]"/>{v.capacity}
              </div>
              <Link to="/book" className="btn-ghost">Reserve <ArrowRight size={14}/></Link>
            </div>
          </div>
        ))}
      </section>
      <Footer/>
    </div>
  );
}
